import React from "react";
import logger from "logger";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { TextField } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import FilterListIcon from "@material-ui/icons/FilterList";
import { withRouter } from "react-router-dom";

import SMSTableRow from "./SMSTableRow";

const columns = [
  { id: "alias_email", label: "Alias/Email", minWidth: 50, align: "center" },
  // { id: "email", label: "Email", minWidth: 50, align: "left" },
  //{ id: "alias", label: "Alias", minWidth: 50, align: "center" },
  { id: "servers", label: "Servers", minWidth: 50, align: "center" },
  {
    id: "accountValidityInSecs",
    label: "Validity",
    minWidth: 50,
    align: "center",
  },
  { id: "actions", label: "Actions", minWidth: 50, align: "center" },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

function Component(props) {
  const classes = useStyles();
  const { data } = props;
  //const data = [];
  const [namefilter, setNamefilter] = React.useState(null);
  const [labelfilter, setLabelfilter] = React.useState(null);
  const [senderfilter, setSenderfilter] = React.useState(null);

  const refreshData = () => {};

  React.useEffect(() => {
    refreshData();
  }, []);

  data.forEach((row) => {
    row.alias_email = {
      alias: row.alias,
      email: row.email,
    };
  });

  logger.log("AccountsTable,data",data);

  let filteredData = data.filter((row) => {
    let filterCriteria = namefilter;
    let filterText = row.email || "";
    if (filterCriteria && filterCriteria.trim().length > 0) {
      if (filterText.indexOf(filterCriteria) === -1) {
        return false;
      }
    }
    filterCriteria = senderfilter;
    filterText = row.servers.join(",") || "";
    if (filterCriteria && filterCriteria.trim().length > 0) {
      if (filterText.indexOf(filterCriteria) === -1) {
        return false;
      }
    }
    filterCriteria = labelfilter;
    filterText = JSON.stringify(row.alias) || "";
    if (filterCriteria && filterCriteria.trim().length > 0) {
      if (filterText.indexOf(filterCriteria) === -1) {
        return false;
      }
    }
    return true;
  });

  return (
    <Paper className={classes.root}>
      <Toolbar>
        <FilterListIcon fontSize={"large"} />
        <FilterField
          label="Email"
          value={namefilter}
          setFiler={setNamefilter}
        />
        <FilterField
          label="Alias"
          value={labelfilter}
          setFiler={setLabelfilter}
        />
        <FilterField
          label="Server"
          value={senderfilter}
          setFiler={setSenderfilter}
        />
      </Toolbar>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={"center"}
                  style={{
                    minWidth: column.minWidth,
                    fontWeight: "bold",
                    backgroundColor: "grey",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((row) => {
              return <SMSTableRow row={row} key={row.id} columns={columns} />;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default withRouter(Component);

const FilterField = ({ label, value, setFiler }) => {
  return (
    <TextField
      style={{ margin: "5px" }}
      margin="dense"
      label={label}
      fullWidth
      variant="outlined"
      value={value}
      onChange={(event) => {
        setFiler(event.target.value);
      }}
    />
  );
};
